module.exports = "<div class=\"container-fluid\">\r\n  <div *ngIf=\"spells$ | async as spells; else loading\">\r\n    <app-spell-view [spells]=\"spells\">\r\n\r\n    </app-spell-view>\r\n  </div>\r\n  <ng-template #loading>\r\n    <div class=\"message\">\r\n      Loading spells...\r\n    </div>\r\n  </ng-template>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/spell-dashboard/containers/spell-dashboard/spell-dashboard.component.html
// module id = ./src/spell-dashboard/containers/spell-dashboard/spell-dashboard.component.html
// module chunks = main